// API 配置

// 是否使用 Mock 数据
export const USE_MOCK = import.meta.env.VITE_USE_MOCK === 'true'

// API 基础路径
export const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

// 请求超时时间（毫秒）
export const REQUEST_TIMEOUT = 30000

// 请求头配置
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
}
